<div dropdown container="body" class="dropdown h-100" aria-haspopup="true" [dropup]="isDropup" placement="bottom right" (isOpenChange)="onSettingsOpenChange($event)">
    <div dropdownToggle class="topbar-item" [ngClass]="{'pointer-events-none': !isLoginForFirstTime}" aria-expanded="false">
        <div [class]="customStyle" (click)="imageLoad()" pTooltip="{{'Settings' | localize}}" tooltipPosition="bottom">
            <i class="flaticon2-gear"></i>
        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu settings-topbar-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-md dropdown-menu-right w-md-300px" [attr.aria-label]="l('Languages')">
        <perfect-scrollbar>
            <div class="d-flex flex-column pl-2 pl-md-9 pt-2 pt-md-7 pb-2 pb-md-7 bgi-size-cover bgi-no-repeat rounded-top "
                 [ngStyle]="{ 'background': 'url(' + 'assets/common/images/header/settings_bg1.svg)', 'background-size': 'cover'}">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-50 mr-2 mr-md-3">
                        <div class="symbol-label">
                            <img [src]="companyImgURL?companyImgURL : 'assets/common/images/header/defaultCompanyImage.svg'" class="symbol-label" />
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="font-weight-bold font-size-h5 text-white topbar-username">
                            <span class="tenancy-name">{{this.companyName}}</span>
                        </span>
                        <div class="navi mt-2">
                            <span class=" text-white font-size-h6-sm">
                                {{"Settings" | localize}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navi navi-hover my-1 mx-2 ps">

                <a Class="navi-item cursor-pointer" *ngIf="isGranted('Pages.CompanyProfile')">
                    <div class="navi-link" (click)="getCompanyProfile()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Company-Profile.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"CompanyProfile" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a Class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.OrganizationUnits')">
                    <div class="navi-link" (click)="getOrganizationUnit()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/My-Profile.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"OrganizationUnit" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a Class="navi-item cursor-pointer" *ngIf="isGranted('Pages.ProductService')">
                    <div class="navi-link" (click)="getProductAndServiceNew()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Products-Services1.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"ProductServices" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a Class="navi-item cursor-pointer" *ngIf="isGranted('Pages.User.ViewUsers')">
                    <div class="navi-link" (click)="getMangeUser()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/manage-user.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"ManageUsers" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a *ngIf="canViewKeka" Class="navi-item cursor-pointer">
                    <div class="navi-link" (click)="getKeka()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Apps-Integations.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                Keka
                            </div>
                        </div>
                    </div>
                </a>
                <a *ngIf="isGranted('Pages.AppProductivity')" Class="navi-item cursor-pointer">
                    <div class="navi-link" (click)="getAppCategory()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Productivity.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"AppProductivity" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
                <a *ngIf="isGranted('Pages.AppProductivity')" Class="navi-item cursor-pointer">
                    <div class="navi-link" (click)="getMasters()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/LookupMetadata.svg" height="38" />
                        </div>
                        <div class="navi-text">
                            <div class="">
                                {{"LookupMetadata" | localize}}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="navi-text mx-2">
                <div class="">
                    <div class="pl-7 pb-5 pt-1" style="color: gray;"> {{_appSession.webAppVersion}}</div>
                </div>
            </div>
        </perfect-scrollbar>
    </div>
</div>
